import React from 'react'
import checkeredFlag from '../../genericComponents/assets/checkered-flag.svg'
import ImageMarker from '../../map/markers/ImageMarker'
import SVGIcon from '../../svg/SVGIcon'
import s from './ArrivalMarkerHTML.less'
import markerGrey from './marker-fond-gris.png'

const ArrivalMarkerHTML = ({ width = 31, height = 37 }) => {
  return (
    <div className={s.arrivalMarker} style={{ width, height }}>
      <ImageMarker height={height} width={width} src={markerGrey} />
      <span className={s.arrivalMarkerFlag}>
        <SVGIcon url={checkeredFlag} ssrWhite />
      </span>
    </div>
  )
}

export default ArrivalMarkerHTML
